/**
 * @desc 平台站点-查询站点详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlatformSiteResponseDto>;
export function request(id: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformSite/details/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
